import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as AssetLevel from 'asset_level/components';
import AssetLevelFormHandlers from 'asset_level/containers/AssetLevelFormHandlers';

import { getIsSaving, getIsFetching, getEditing, getIsFetchingConfig } from 'asset_level/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';

import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups
import { getVisibleRoles } from 'roles/selectors'; //Groups

class AssetLevelFormContainer extends Component {
  render = () => (
    <AssetLevelFormHandlers
      render={({
        handleSubmit,
        handleValidation,
        handleValueChange,
        isSubmitted,
        handleGroupChange, //Groups
        handleCustomFieldChange, //Groups
        isSaving,
      }) => (
        <AssetLevel.FormView
          company={this.props.company}
          asset_level={this.props.asset_level}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isFetching={this.props.isFetching}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={this.props.groups} //Groups
          roles={this.props.roles} //Roles
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          subcompany={this.props.subcompany}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  asset_level: getEditing(state),
  company: getCompany(state),
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
  roles: getVisibleRoles(state), //Roles
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(AssetLevelFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/containers/AssetLevelFormContainer.js